import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// React Icons
import { TbFileInvoice } from 'react-icons/tb'
import { FiSettings } from 'react-icons/fi'
import { AiOutlineDashboard } from 'react-icons/ai'
import { HiOutlineDocumentReport } from 'react-icons/hi'
import { RiMenuUnfoldFill, RiMenuFoldLine } from 'react-icons/ri'

// Custom hooks
import { useTenant } from '../hooks'

const MenuSide = ({ openMenu, setOpenMenu }) => {
    const [t] = useTranslation('global')
    const { tenantUsername } = useTenant();

    const menuItems = [
        {
            to: `/${tenantUsername}`,
            icon: <AiOutlineDashboard size={22} />,
            label: t('menu.Dashboard'),
            end: true
        },
        {
            to: `/${tenantUsername}/rating-services`,
            icon: <TbFileInvoice size={22} />,
            label: t('menu.RatingServices'),
            end: true
        },
        {
            to: `/${tenantUsername}/reports`,
            icon: <HiOutlineDocumentReport size={22} />,
            label: t('menu.Reports'),
            end: true
        },
        {
            to: `/${tenantUsername}/settings`,
            icon: <FiSettings size={22} />,
            label: t('settings.title'),
            end: true
        }
    ];

    return (
        <div
            className={`z-40 h-screen transition-all duration-500 ease-in-out primary-bg-color border-e border-white/10 shadow-2xl ${openMenu ? 'w-64' : 'w-20'}`}>
            <div className='flex flex-col h-full py-8'>
                <div className={`flex ${openMenu ? 'justify-end' : 'justify-center'} px-3 mb-6`}>
                    <button
                        type="button"
                        onClick={() => setOpenMenu(!openMenu)}
                        className='text-white/70 hover:text-white transition-colors'
                        title={openMenu ? t('common.closeMenu') : t('common.openMenu')}
                        aria-label={openMenu ? t('common.closeMenu') : t('common.openMenu')}
                    >
                        {openMenu ? <RiMenuFoldLine size={22} /> : <RiMenuUnfoldFill size={22} />}
                    </button>
                </div>
                <ul className='flex flex-col gap-2 px-3'>
                    {menuItems.map((item, index) => (
                        <li key={index} className='w-full'>
                            <NavLink
                                to={item.to}
                                end={item.end}
                                className={({ isActive }) => `
                                    flex items-center gap-4 px-4 py-3.5 rounded-2xl transition-all duration-300 group
                                    ${isActive
                                        ? 'bg-white/15 text-white shadow-lg backdrop-blur-md border border-white/10'
                                        : 'text-white/60 hover:bg-white/5 hover:text-white'}
                                `}
                            >
                                <div className={`flex items-center justify-center transition-transform duration-300 group-hover:scale-110 ${openMenu ? '' : 'w-full'}`}>
                                    {item.icon}
                                </div>
                                {openMenu && (
                                    <span className='font-medium text-sm whitespace-nowrap overflow-hidden animate-fadeIn'>
                                        {item.label}
                                    </span>
                                )}
                            </NavLink>
                        </li>
                    ))}
                </ul>

                <div className='mt-auto px-6 pb-4'></div>
            </div>
        </div>
    )
}

export default MenuSide
